import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section";
import {getNavigationPosition} from "../../navigation/functions/get-navigation-position";
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click";
import MainMenu_Reports from "../../../../layout/menu/sections/reports/menu-reports";
import ProjectSession from "../../project/project-session";
import {ProjectSystemType} from "../../project/types";
import NavigationMenu_ReportsContent from "../../../../layout/menu/sections/reports/menu-content";
import {featureAccess} from "../../../gd/access-control/feature-access/feature-access";
import {Feature} from "../../../gd/access-control/feature-access/const";


export class SpaceReports extends SpaceProto {

    constructor() {
        super(NavigationSectionType.REPORTS)

        this.title      = "Reports"
        this.svgIcon    = "isvg-reports-space"

        this.defaultPosition    = NavigationButtonPosition.MORE
    }

    onClick = () => {

        if (!featureAccess(Feature.REPORTS)) {
            gd.modals.other.upgrade(Feature.REPORTS)
            return
        }

        navigationStructureOnClick(this.navigation)
    }

    get navigationStructureConfig() {
        return {
            id              : this.id,
            icon            : "i5-chart-bar",
            hint            : "Reports",
            type            : NavigationSectionType.REPORTS,
            renderComponent : Navigation_ButtonGenericDeprecated,
            menuComponent   : MainMenu_Reports,
            menuContent     : NavigationMenu_ReportsContent,
            onClick         : this.onClick,
            position        : getNavigationPosition(NavigationSectionType.REPORTS)
        }
    }

    get reports() {

        const filteredReports: ProjectSession[] = []

        gd.session.projects.models.map((project: ProjectSession)=> {

            // only no parent reports displayed here
            if (project.systemType === ProjectSystemType.REPORT_VIEW && !project.parentId) {
                filteredReports.push(project)
            }
        })

        return filteredReports
    }

    initNavigation() {
        if (!gd.user.isUser) return

        super.initNavigation()
    }
}
